import React, { useEffect, useState } from 'react';
import { beginVkId, isVkIdEnabled } from '../../services/vkIdClient';

/**
 * Always show the VK sign-in option in the UI. If the OAuth app is not yet
 * configured, tell the user why the button cannot be used instead of silently
 * hiding it. A fresh check is made when the component mounts.
 */
export default function VkIdButton({ mode = 'login', onError, className = '' }) {
  const [status, setStatus] = useState('checking');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let active = true;
    isVkIdEnabled()
      .then(enabled => { if (active) setStatus(enabled ? 'ready' : 'unavailable'); })
      .catch(() => { if (active) setStatus('unavailable'); });
    return () => { active = false; };
  }, []);

  const ready = status === 'ready';
  const blocked = !ready || busy;
  const caption = mode === 'link'
    ? 'Привязать VK ID'
    : 'Войти / зарегистрироваться через VK ID';

  const handleClick = async () => {
    if (blocked) return;
    setBusy(true);
    try {
      await beginVkId({ mode });
    } catch (error) {
      setBusy(false);
      if (onError) onError(error?.message || 'Ошибка VK ID');
      else window.alert(error?.message || 'Ошибка VK ID');
    }
  };

  return (
    <div className="vkIdSignIn">
      <button
        type="button"
        className={className}
        disabled={blocked}
        aria-disabled={blocked}
        onClick={handleClick}
        style={{
          display: 'block',
          width: '100%',
          padding: '12px 16px',
          borderRadius: 10,
          border: '1px solid #4c75a3',
          background: ready ? '#0077ff' : '#e5ecf7',
          color: ready ? '#fff' : '#53657d',
          fontWeight: 700,
          cursor: blocked ? 'not-allowed' : 'pointer',
          opacity: busy ? 0.7 : 1,
        }}
      >
        {busy ? 'Переход в VK ID…' : caption}
      </button>
      {status === 'checking' && (
        <div role="status" style={{ fontSize: 12, color: '#68758b', paddingTop: 6 }}>
          Проверяем подключение VK ID…
        </div>
      )}
      {status === 'unavailable' && (
        <div role="status" style={{ fontSize: 12, color: '#68758b', paddingTop: 6 }}>
          VK ID пока недоступен. Нужно завершить настройку приложения в ALOTB.
        </div>
      )}
    </div>
  );
}
